import { useEffect, useState } from "react";
import { useMenuSelectors } from "../../../../app/state/menuSlice/hook/use-menu-selectors";
import { usePopoverSelectors } from "../../../../app/state/popoverSlice/hook/use-popover-selectors";
import styles from "./styles.module.css";

export const FrameOverlay = () => {
  const headerServiceManager = usePopoverSelectors(
    "header_service_manager_popover",
  );
  const sidebarMenu = useMenuSelectors("sidebar_item_actions_menu");
  const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(false);

  useEffect(() => {
    if (headerServiceManager.isOpen === true || sidebarMenu.isOpen === true) {
      setIsOverlayOpen(true);
    } else {
      setIsOverlayOpen(false);
    }
    return () => {
      setIsOverlayOpen(false);
    };
  }, [headerServiceManager.isOpen, sidebarMenu.isOpen]);

  return <>{isOverlayOpen && <div className={styles["frame-overlay"]} />}</>;
};
